/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const productDetailsPriceStrikethruSX: SxProps<Theme> = {
	color: (theme) => theme.palette.text.secondary,
	textDecoration: 'line-through',
	fontWeight: '400',
};

export const productDetailsPriceSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-sm)',
	letterSpacing: '0px',
	color: '#2C2C2C',
	fontWeight: 'bold',
	opacity: 1,
	lineHeight: 1,
};

export const productDetailsPriceOfferSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-sm)',
	letterSpacing: '0px',
	color: '#2c2c2c',
	fontWeight: '600',
	opacity: 1,
	lineHeight: 1,
};

export const productDetailsPriceListSX: SxProps<Theme> = {
	color: '#939393',
	fontSize: 'var(--font-size-sm)',
	letterSpacing: '0px',
	fontWeight: 'normal',
	opacity: 1,
	textDecoration: 'line-through',
	lineHeight: 1.1,
};
